(function($) {

    $(".hero-slider").slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        rows: 0,
    });

    var delay = 400;
    $('.hero .button-container .button').each(function(){
        var ele = $(this);
        delay += 400;
        setTimeout(function(){
            ele.css({
                opacity: 1
            });
        }, delay);
    });

})( jQuery );